<template>
  <section class="v-page-section-container-padding col-span-full relative z-20 container mx-auto md:flex lg:grid grid-cols-2 2xl:grid-cols-12 gap-5 lg:gap-8">
    <div class="relative z-20 bg-white rounded-3xl px-7 sm:px-9 md:px-5 xl:px-10 py-5 sm:py-10 mb-5 md:mb-0 2xl:col-span-5 2xl:col-start-2">
      <ul class="sm:flex sm:gap-5 md:gap-2 lg:gap-2 xl:gap-5">
        <li class="mb-3 sm:mb-0 searchColumn">
          <h2 class="text-black mb-4 xl:mb-6 text-xl sm:text-base md:text-base lg:text-lg xl:text-xl font-medium leading-none">
            {{ $t('home-search-input-title') }}
          </h2>
          <div class="relative">
            <input
              v-model="concertSearchInput"
              type="text"
              :placeholder="`${$t('home-search-input-placeholder')}`"
              class="c-home-search-input italic"
              @keydown.enter="commitInputSearch"
            />
            <AtomIconSearch class="absolute top-0 right-0 mt-3 mr-4 md:mr-5 w-4 h-4 text-black hover:text-app-primary-1-red--torch cursor-pointer" @click="commitInputSearch" />
          </div>
        </li>
        <li class="searchColumn">
          <h2 class="text-black mb-4 xl:mb-6 text-xl sm:text-base md:text-base lg:text-lg xl:text-xl font-medium leading-none">
            {{ $t('home-date-input-title') }}
          </h2>
          <!--
            New datepicker kept for later sprint rollout.
          <MoleculeDatepicker
            background-color="bg-app-primary-grey--black-squeeze hover:bg-app-primary-1-red--fire-brick"
            text-color="text-black hover:text-white"
            icon-color="text-black group-hover:text-white"
            size="large"
            :enable-icon-left="false"
            :shadowed="false"
            :justified="true"
            :icon-size="4"
            class-list="w-full group"
            @set-date="commitDatePickerSearch"
          />
          -->
          <MoleculeDatepickerLegacy
            background-color="bg-app-primary-grey--black-squeeze hover:bg-app-primary-1-red--fire-brick"
            text-color="text-black hover:text-white"
            icon-color="text-black group-hover:text-white"
            size="large"
            :enable-icon-left="false"
            :shadowed="false"
            :justified="true"
            :icon-size="4"
            class-list="w-full group"
            @set-date="commitDatePickerSearch"
          />
        </li>
      </ul>
    </div>
    <div v-if="recommendationUrl" class="relative z-10 bg-white rounded-3xl px-7 sm:px-9 md:px-5 xl:px-12 py-5 sm:py-10 2xl:col-span-5">
      <h2 class="text-black mb-4 xl:mb-6 text-xl sm:text-base md:text-base lg:text-lg xl:text-xl font-medium leading-none">
        {{ $t('home-search-help-title') }}
      </h2>
      <MoleculeButton class="w-full xl:hidden" size="large" background-color="bg-app-primary-1-red--fire-brick hover:bg-black" @click="startQuestionnaire">{{
        $t('home-search-help-button')
      }}</MoleculeButton>
      <MoleculeButton class="hidden w-full xl:flex" background-color="bg-app-primary-1-red--fire-brick hover:bg-black" @click="startQuestionnaire">{{
        $t('home-search-help-button')
      }}</MoleculeButton>
    </div>
  </section>
</template>

<script setup lang="ts">
import { toLocalDateString } from '~/assets/util'
import { explodeUrl } from '@/assets/link'

const props = defineProps({
  recommendationUrl: { type: String, required: false, default: undefined },
  genres: { type: Array as PropType<any[]>, required: false, default: () => [] },
})

const router = useRouter()
const globalStore = useGlobalStore()
const recommendationsStore = useRecommendationsStore()
const concertSearchInput = ref('')
const commitInputSearch = () => {
  const path = explodeUrl(globalStore.eventOverview?.url || '').path
  router.push({ path, query: { keyword: concertSearchInput.value || undefined } })
}
const commitDatePickerSearch = (date: Date) => {
  const path = explodeUrl(globalStore.eventOverview?.url || '').path
  router.push({ path, query: { date: toLocalDateString(date) } })
}
const startQuestionnaire = () => {
  recommendationsStore.reset()
  const path = explodeUrl(props.recommendationUrl || '').path
  router.push({ path })
}
</script>

<style lang="scss" scoped>
.c-home-search-heading {
  @apply text-lg font-medium leading-none mb-3;
}

.c-home-search-border {
  @apply border-app-primary-grey--black-squeeze border-solid border-t-0;
  border-bottom-width: 3px;
}

.c-home-search-input {
  @apply pl-6 pr-10 w-full rounded-3xl bg-app-primary-grey--black-squeeze min-h-10;
  min-width: 230px;

  &::placeholder {
    @apply font-normal text-black;
  }

  @screen md {
    @apply text-sm pr-8;
  }

  @screen xl {
    min-height: 42px;
  }
}

.column {
  @apply flex flex-col;
}
</style>
